import React, { useState, useEffect } from 'react'
import {backgroundDark,backgroundLight} from "../assets/images"
import { useStateContext } from '../context/ContextProvider'
import { Footer, Header } from '../components/layout'
import { useParams } from 'react-router-dom'
import { footerData } from '../constants'
import {IoCheckmarkCircle,IoCheckmarkCircleOutline} from "../components/icons"
import { renderText } from '../components/hooks/TextVeiw'



const Privacy_policy_page = () => {
    const {currentMode,currentLang}=useStateContext()
    const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
    const {id} = useParams()
    const [open ,setOpen] = useState(null)
    

    useEffect(() => {
        if (id) {
            setOpen(id)
        }
    }, [id])

    const data = footerData.colom2.links
  
  return (
    <div className='w-full '
    style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    > <Header active={"/"} />
    <div className="container pt-24 pd:mt-32 lg:pt-36 ">
         
    <div className="flex-grow pt-24 pb-12 px-4 md:px-6 lg:pt-28">
                <div className="max-w-4xl mx-auto">
                    <div className="bg-light-glassStrock1 dark:bg-dark-glass1
                        border border-light-glassStrock2 dark:border-dark-glassStrock1 backdrop-blur-xl
                        rounded-xl p-5 md:p-8 shadow-xl">
                        
                        <h1 className='h3 md:h2 text-center text-light-title dark:text-dark-title mb-6 md:mb-8'>
                            {currentLang === "ar" ? footerData.colom2.title_Ar : footerData.colom2.title_En}
                        </h1>
                        
                        <div className="space-y-4">
        {
data.map((item)=>(

    <div key={item.id} className="bg-light-glass2 dark:bg-dark-glass2
    border border-light-glassStrock dark:border-dark-glassStrock1 
    rounded-xl overflow-hidden transition-all p-2 duration-300 ease-out">
       <div  className="flex items-center p-4 cursor-pointer group" onClick={()=>setOpen(item.id)}>
       <span className={`transition-all duration-300 ${open == item.id ? 'text-light-blue scale-110' : 'text-light-text dark:text-dark-text'}`}>{open == item.id ?  <IoCheckmarkCircle size={24} /> : <IoCheckmarkCircleOutline size={24}  />}</span>

       <h3 className='h5 text-light-title dark:text-dark-title mr-3 transition-colors duration-300 group-hover:text-light-blue dark:group-hover:text-dark-blue'>
        {currentLang ==="ar" ?item.title_Ar:item.title_En}
        </h3>
    </div>
    <div className=" px-4">
        {open == item.id && <p>
        {renderText(currentLang ==="ar" ?item.description_Ar:item.description_En ,"body-1 text-light-text dark:text-dark-text")}
        </p>} 
       
    </div>
  </div>
   
))
        }
        </div>
</div>
</div>
</div>
    </div>
          <Footer />
        </div>
  )
}

export default Privacy_policy_page